const organizationalStructure = {
  state: {
    tableParams: {}
  },
  mutations: {
    setTableParams: (state, tableParams) => {
      state.tableParams = tableParams
    }
  },
  actions: {}
}
export default organizationalStructure
